import React, { useContext } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { showToast } from "../../utils/toastUtils";
import RejectUser from "../../Apis/rejectUser";
import MyContext from "../../Context/AppContext";

const RejectUserDialog = (props) => {

  const { open, onClose, userData, pendingRowAdjustment, setKendoDataLoading } = props;
  const { userDetails } = useContext(MyContext);

  const handleConfirm = async () => {
    try {
      let payload = {
        rejectedBy: userDetails?._id
      }
      let response = await RejectUser(userData._id, payload);
      if (response.status === 200) {
        setKendoDataLoading(true);
        showToast("User Rejected", "success");
        onClose();
        pendingRowAdjustment(userData);
      }
    } catch (error) {
      showToast("Something went wrong", "error");
      console.log(error);
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Rejection</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to reject the user?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={() => handleConfirm()} color="error" variant="contained">
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectUserDialog;